// extracted by mini-css-extract-plugin
export default {"root":"OrderSuccessBlock_root__V9Tvt","description":"OrderSuccessBlock_description__oabOc"};